import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
} from '@mui/material';
import { staticFileLocation } from '@server/constants';
import { LoadingButton } from '@mui/lab';
import { setCookie } from '@utils/getCookie';

interface JobClosedSuggessionModalProps {
  open: boolean;
  type: number;
  onProactivelyRecruit: () => void;
  onCloseMyJob: () => void;
  onCloseDialog: () => void;
}

const JobClosedSuggessionModal: React.FC<JobClosedSuggessionModalProps> = ({
  open,
  type,
  onProactivelyRecruit,
  onCloseMyJob,
  onCloseDialog,
}) => {
  return (
    <Dialog open={open} onClose={onCloseDialog} maxWidth="xs" fullWidth>
      <DialogContent sx={{ textAlign: 'center', p: 4 }}>
        <Box mb={2}>
          <img
            src={`${staticFileLocation}img/logos/LogoStampShadow.png`}
            alt="Logo"
            style={{
              width: 60,
              height: 80,
              margin: '0 auto',
              objectFit: 'contain',
            }}
          />
        </Box>
        {type === 1 && (
          <Typography variant="body2" color="textSecondary" gutterBottom>
            We had noticed you had closed jobs...
          </Typography>
        )}
        <Typography
          variant="h3"
          fontWeight={900}
          color="primary.main"
          mt={2}
          mb={1}
        >
          {type === 0 ? 'Just a Suggestion!' : 'Here’s a Pro Tip!'}
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          (Take it or leave it…)
        </Typography>
        <Typography
          variant="subtitle1"
          color="gray"
          sx={{ fontWeight: 700, mt: 2 }}
        >
          Fully staffed is a moment, not a status.
        </Typography>
        <Typography
          color="gray"
          variant="body2"
          sx={{ fontWeight: 500, mt: 1, mb: 3, maxWidth: 260, mx: 'auto' }}
        >
          We suggest the “Always Accepting” approach to proactively recruit &
          hire fast when you need to. Trust us on this one.
        </Typography>
        <DialogActions sx={{ justifyContent: 'center', gap: 2 }}>
          <LoadingButton
            variant="contained"
            color="primary"
            onClick={onProactivelyRecruit}
            sx={{ width: '170px' }}
            size="small"
          >
            Proactively Recruit
          </LoadingButton>
          <LoadingButton
            size="small"
            variant="outlined"
            onClick={onCloseMyJob}
            sx={{ width: '170px' }}
          >
            {type === 0 ? 'Close My Job' : 'No Thanks '}
          </LoadingButton>
        </DialogActions>
        {type === 0 && (
          <Button
            variant="text"
            color="info"
            sx={{
              marginTop: '-12px',
              fontSize: '13px',
              justifyContent: 'flex-end',
              width: '80%',
              fontStyle: 'italic',
              cursor: 'pointer',
            }}
            onClick={() => {
              setCookie('hideJobClosedSuggestion', 'true', 5);
              onCloseDialog();
            }}
          >
            Don’t show again
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default JobClosedSuggessionModal;
